import React from 'react'
 function ThirdComponent(){
       return(
      <div className="thirdComponent">
            HELLO  DEVELOPERSS!!!!
      </div>
    )
}
export default ThirdComponent